import { createAction, props } from '@ngrx/store';

export const updateRefreshData = createAction(
    '[AUTH] update refresh data',
    props<{ value: boolean }>(),
);
